<template>
    <span>
        <i v-if="!employer.is_active" class="fa fa-eye-slash" aria-hidden="true" style="color: #e64e42;" title="No Jobs Displayed: Employer Account Inactive"></i>
        <i v-if="employer.all_jobs_inactive" class="fa fa-eye-slash" aria-hidden="true" style="color: #e64e42;" title="No Jobs Displayed: All Jobs Inactive"></i>
        <i v-if="employer.over_budget_color" class="fa fa-dollar" aria-hidden="true" :style="`color: ${employer.over_budget_color};`" :title="`${employer.over_budget_color === 'red' ? 'All' : 'Some' } campaigns are over budget`"></i>
        <i v-if="employer.is_self_service" class="fa fa-sign-language" aria-hidden="true" style="color: #2babde" title="Self-service"></i>
	    <i v-if="employer.is_tenstreet" class="fa fa-chevron-circle-right" aria-hidden="true" style="color: #2babde" title="Tenstreet"></i>
	    <span v-if="employer.trial" class="label label-info">TRIAL</span>
    </span>
</template>

<script>
    export default {
        props: [
            'employer'
        ]
    }
</script>
